import React, {Component} from 'react'
import { PhoneInput } from 'react-international-phone'
import { validateEmail } from '../../utils/helpers'

class Mtm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      phone: '',
      nameError: null,
      emailError: null,
      msgError: null,
      filled: false,
      country: Shopify.country == 'JP' ? 'Japanese' : (Shopify.country == 'KR' ? 'Korean' : 'English'),
    }
    this.formRef = React.createRef();
    this.phoneInputRef = React.createRef();
    this.phoneLabelId = 'phone-input-label';
  }

  componentDidMount() {
    this.linkLabelToPhoneInput();
  }

  componentDidUpdate() {
    this.linkLabelToPhoneInput();
  }

  linkLabelToPhoneInput = () => {
    if (this.phoneInputRef.current) {
      const inputElement = this.phoneInputRef.current;
      inputElement.setAttribute('id', this.phoneLabelId);
    }
  }

  validateForm(e) {
    const form = this.formRef.current
    let hasError = false
    if(form.querySelector('[name="00N8c00000hQBwk"]').value?.trim() == '') {
      hasError = true
      this.setState({ nameError: window.pageStrings.mtm.errors.firstName })
    }
    if(!validateEmail(form.querySelector('[name="email"]').value?.trim())) {
      hasError = true
      this.setState({ emailError: window.pageStrings.mtm.errors.email })
    }
    if(form.querySelector('[name="description"]').value?.trim() == '') {
      hasError = true
      this.setState({ msgError: window.pageStrings.mtm.errors.text })
    }
    if(hasError) {
      e.preventDefault()
      e.stopPropagation()
    }
  }
  updateFilledState() {
    const form = this.formRef.current
    let hasError = false
    if(form.querySelector('[name="00N8c00000hQBwk"]').value?.trim() == '') hasError = true
    if(form.querySelector('[name="email"]').value?.trim() == '') hasError = true
    if(form.querySelector('[name="description"]').value?.trim() == '') hasError = true
    this.setState({ filled: !hasError })
  }
  render() {
    return (
      <form
        className='grid grid-cols-1 gap-6'
        noValidate
        action="https://thombrowneinc.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8&orgId=00D8c000002dqqJ"
        method="POST"
        ref={this.formRef}
      >
        <input type="hidden" id="OrgId" name="orgid" value="00D8c000002dqqJ" />
        <input type="hidden" id="retURL" name="retURL" value={ `${window.shopUrl}${Shopify.country == 'JP' ? '/ja-jp' : ''}${Shopify.country == 'KR' ? '/ko-kr' : ''}/pages/made-to-measure?formsubmit=true` } />
        <input type="hidden" name="recordType" id="recordType" value="0128c000001SDti" />
        <input type="hidden" 
          id="Language__c" 
          name="00N8c00000hQBwi" 
          value={this.state.country} 
          />
        <input type="hidden" id="Type" name="type" value="Product Information" />
        <input
          type="hidden"
          id="SubType__c"
          name="00N8c00000hQBx4"
          value="Made to measure/customization"
        />
        <input type="hidden" id="Priority" name="priority" value="200" />
        <input type="hidden" id="Origin" name="origin" value="Web" />
        <input type="hidden" id="Purchase_Channel__c" name="00N8c00000hQBwm" value="Retail" />

        <div className="grid lg:grid-cols-2 gap-5">
          <div className={`input-wrap input-wrap--line ${this.state.nameError ? 'input-error' : ''}`}>
            <input type="text" 
              name="00N8c00000hQBwk" 
              id="first-name" 
              placeholder={window.pageStrings.mtm.firstName}
              onChange={e => {
                this.setState({ nameError: null })
                this.updateFilledState()
              }}
              required 
              onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
              onBlur={e => {
                e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
              }}
            />
            <label htmlFor="first-name">{window.pageStrings.mtm.firstName}</label>
            { this.state.nameError && 
              <div className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>{this.state.nameError}</div> 
            }
          </div>
          <div className="input-wrap input-wrap--line">
            <input type="text" 
              name="00N8c00000hQBwr" 
              id="last-name" 
              placeholder={window.pageStrings.mtm.lastName}
              onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
              onBlur={e => {
                e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
              }}
            />
            <label htmlFor="last-name">{window.pageStrings.mtm.lastName}</label>
          </div>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-5">
          <div className={`input-wrap input-wrap--line ${this.state.emailError ? 'input-error' : ''}`}>
            <input type="email" 
              name="email" 
              id="email" 
              placeholder={window.pageStrings.mtm.email} 
              onChange={e => {
                this.setState({ emailError: null })
                this.updateFilledState()
              }}
              required
              onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
              onBlur={e => {
                e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
              }} 
            />
            <label htmlFor="email">{window.pageStrings.mtm.email}</label>
            { this.state.emailError && 
              <div className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>{ this.state.emailError }</div> 
            }
          </div>
          <div className="flex flex-col justify-end">
            <div className="input-wrap input-wrap--line relative">
              <label htmlFor={this.phoneLabelId} className='sr-only'>{window.pageStrings.mtm.phone}</label>
              <PhoneInput
                defaultCountry={Shopify.country.toLowerCase()}
                value={this.state.phone}
                name="phone"
                onChange={(phone) => this.setState({phone})}
                inputRef={this.phoneInputRef}
              />
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1">
          <div className={`input-wrap input-wrap--line ${this.state.msgError ? 'input-error' : ''}`}>
            <textarea name="description" 
              id="description"
              className='!normal-case !h-[2.75rem] focus:!h-[5.625rem] lg:!h-[5.625rem]' 
              placeholder={window.pageStrings.mtm.textPlaceholder}
              onChange={e => {
                this.setState({ msgError: null })
                this.updateFilledState()
              }} 
              required 
            />
            <label htmlFor="description">{window.pageStrings.mtm.textLabel}</label>
            { this.state.msgError && 
              <div className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>{ this.state.msgError }</div> 
            }
          </div>
        </div>
        
        <div>
          <input className={`button !rounded-none !w-full mt-1 ${this.state.filled ? 'button--primary' : ''}`}
            type="submit" 
            value={window.pageStrings.mtm.sendMessage}
            onClick={e => this.validateForm(e)}
            disabled={!this.state.filled}
          />
          {
            location.search.includes('formsubmit=true') && <div className="mt-2 text-xs">{window.pageStrings.mtm.thankyou}</div>
          }
        </div>
      </form>
    )
  }
}

export default Mtm